import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AlertService {

    constructor(
        private router: Router,
        private toasterService: ToastrService,
    ) { }

    success(message: string) {
        this.toasterService.success(message);
    }

    error(message: string) {
        this.toasterService.error(message);
    }
}



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/services/alert/alert.service.ts